import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, message, Typography, Skeleton, Table, notification } from "antd";

import { getControlsDeleted, getControlsDeletedByCode } from "../../../../API/controls";

import WithPermission from "../../../Common/WithPermission/WithPermission";
import BackButton from "../../../Common/BackButton/BackButton";
import BreadCrumb from "../../../Common/BreadCrumb/BreadCrumb";
import ExportButton from '../../../Common/ExportButton/ExportButton';
import ChangeLog from "../../../Common/ChangeLog/ChangeLog";
import PageTitle from "../../../Common/PageTitle/PageTitle";
import ControlSearch from "../ControlSearch/ControlSearch";
import Columns from "./columns";

import { useAuth } from "../../../Context/AuthContext";

const ControlsDeleted = () => {
  const navigate = useNavigate();
  // Permisos
  const { hasPermission, userData } = useAuth();
  // Consulta permisos: Superusuario  
  const isSuperuser = userData?.is_superuser === true;
  // Notificaciones
  const [api, contextHolder] = notification.useNotification();
  // Data
  const [controlsDeleted, setControlsDeleted] = useState(null);
  // Buscador
  const [filteredData, setFilteredData] = useState([]); 
  const [searchText, setSearchText] = useState(''); 

  useEffect(() => {
    const fetchControlsDeleted = async () => {
      try {
        const data = await getControlsDeleted();
        setControlsDeleted(data);
        setFilteredData(data);
      } catch (error) {
        message.error("No se encontraron los controles eliminados.");
      }
    };

    fetchControlsDeleted();
  }, []);

  const breadCrumbUrl = [
    { label: "Controles", url: "/controls" },
    { label: "Eliminados" },
  ];

  const goToBioFunctions = () => {
    navigate(-1);
  };

  const [changeLogVisible, setChangeLogVisible] = useState(false);
  const [changeLogData, setChangeLogData] = useState(null);
  const [changeLogLogs, setChangeLogLogs] = useState([]);

  const handleOpenChangeLog = async (record) => {
    try {
      const evaluation = await getControlsDeletedByCode(record.code);
      setChangeLogData(record);
      setChangeLogLogs(evaluation.logs || []);
      setChangeLogVisible(true); 
    } catch (error) {
      api.error({ message: "Error al obtener logs", description: error.message });
    }
  };

  const handleCloseChangeLog = () => {
    setChangeLogVisible(false);
    setTimeout(() => {
      setChangeLogData(null);
      setChangeLogLogs([]);
    }, 300);
  };

  const controlDeletedTableFilter = () => {
    const controlTypes = Array.from(
      new Map(controlsDeleted.map(c => [c.type?.id, c.type]).filter(([id, type]) => id && type)).values()
    );
  
    const controlPriorities = Array.from(
      new Map(controlsDeleted.map(c => [c.priority?.id, c.priority]).filter(([id, p]) => id && p)).values()
    );

    const controlCategories = Array.from(
      new Map(controlsDeleted.map(c => [c.category?.id, c.category]).filter(([id, cat]) => id && cat)).values()
    );
  
    const controlAreas = Array.from(
      new Map(controlsDeleted.map(c => [c.area?.id, c.area]).filter(([id, area]) => id && area)).values()
    );
  
    const controlFrameworks = Array.from(
      new Map(controlsDeleted.map(c => [c.framework?.id, c.framework]).filter(([id, fw]) => id && fw)).values()
    );
  
    return {
      types: controlTypes,
      priorities: controlPriorities,
      categories: controlCategories,
      areas: controlAreas,
      frameworks: controlFrameworks,
    };
  };

  return (
    <WithPermission
      isSuperuser={isSuperuser}
      //hasAnyRole={hasAnyRole}
      requiredPermission="read"
      //currentPermission={canAssetsRead}
      redirectTo="/home"
    >
      <>
        {contextHolder}
        <div className="button-container">
          <Row justify="space-between">
            <Col span={18}>
              <PageTitle title="Controles Eliminados" icon="controls" />
            </Col>
          </Row>

          <Row justify="start" align="top">
            <Col span={18} style={{ display: "flex", alignItems: "center" }}>
              <BackButton onConfirm={goToBioFunctions} />
              <BreadCrumb location={breadCrumbUrl} />
            </Col>
            <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <ControlSearch
                controlsData={controlsDeleted}
                searchText={searchText}
                setSearchText={setSearchText}
                setFilteredData={setFilteredData}
              />
            </Col>
          </Row>

          <Row justify="end">
            <Col span={6} offset={18} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <ExportButton
                api={api}
                contextHolder={contextHolder}
                data={filteredData}
                filename="Activos Eliminados.csv"
                transformData={(data) =>
                  data.map(item => ({
                    Nombre: item.name,
                    Descripción: item.description,
                    Responsable: item.area?.name || 'N/A',
                    "Creado por": item.user?.username || 'N/A',
                  }))
                }
              />
            </Col>
          </Row>
        </div>
      {
        !controlsDeleted ? (
        <>
          <Skeleton active paragraph={{ rows: 6 }} />
          <div style={{ height: 32 }} />
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </Col>
            <Col xs={24} md={12}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </Col>
          </Row>
        </>
        ) : (
          <>
            <Table
              className="custom-pagination deleted-table "
              columns={Columns(handleOpenChangeLog, controlDeletedTableFilter())}
              dataSource={filteredData} 
              rowKey="code"
              scroll={{ y: 450 }}
              pagination={{
                defaultPageSize: 30,
                showSizeChanger: true,
                pageSizeOptions: ["30", "50", "100"],
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} de ${total} registros`,
              }}
            />
            <ChangeLog
              open={changeLogVisible}
              onClose={handleCloseChangeLog}
              data={changeLogData}
              logs={changeLogLogs}
            />
          </>
        )
      }
      </>
    </WithPermission>
  );
};

export default ControlsDeleted;